import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import UserSummary from './UserSummaryComponent';
import { logout } from '@alphapoint/apex-web/lib/redux/actions/authActions';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserSummary));
